// React
import React from 'react';

// Packages
import t from 'prop-types';

// Utilities
import { useInitiativeDataStore } from 'utilities/store';
import { useLabels, useContext } from 'utilities/hooks';

// Components
import BaseCard from './_common/baseCard.js';

// Icons
import { FiTrendingUp } from 'react-icons/fi';

const InitiativeReportsSummary = ({ promptKey, forceOpen }) => {
    // ///////////////////
    // STORES
    // ///////////////////

    const { utilities } = useInitiativeDataStore();

    // ///////////////////
    // HOOKS
    // ///////////////////

    const { INITIATIVE_ID } = useContext();
    const { label } = useLabels();

    // ///////////////////
    // REFS
    // ///////////////////

    // ///////////////////
    // DATA
    // ///////////////////

    const initiative = utilities.initiative.get();
    const reports = utilities.reports.getAll();

    // ///////////////////
    // RENDER
    // ///////////////////

    return (
        <>
            <BaseCard
                {...{
                    forceOpen,
                    title: label('AI_PromptTitle_Initiative_Reports_Summary'),
                    description: label(
                        'AI_PromptDescription_Initiative_Reports_Summary'
                    ),
                    relation: {
                        key: 'Initiative__c',
                        id: INITIATIVE_ID,
                        name: initiative?.Name,
                        type: '',
                    },
                    icon: FiTrendingUp,
                    promptKey,
                    systemPrompts: [
                        'You will help the user to summarize the initiative reports based on the prompts provided.',
                        'If the content is not available or detailed enough, provide a summery where you can, and then ask the user for more details.',
                        'Do not include any general heading or other headings than the sections asked for.',
                        'Do not mention object keys like "Status__c" or anything with __c in them. You may refer but not include them.',
                        'The answer you provide should be in unescaped html tags for immediate parsing.',
                        'No wrapping <div>. Use <p> tags for paragraphs and <strong> for bold text and headings.',
                    ],
                    promptDataGetter: () => JSON.stringify(reports),
                }}
            />
        </>
    );
};

InitiativeReportsSummary.propTypes = {
    promptKey: t.string.isRequired,
};

InitiativeReportsSummary.defaultProps = {
    promptKey: '',
};

export default InitiativeReportsSummary;
